import React from 'react';
import { useLocation } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { useAnimatePage } from '@hooks';
import Header from '@components/Header';
import { AnimationLayout } from '@layouts';
import { useStyles } from './styles';
import Sidebar from '@components/Sidebar';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import { Box, useTheme, useMediaQuery } from '@material-ui/core';
import { useAuthContext, useDrawerContext } from '@hooks';

export function HeaderLayout({ children, title, pageMayClosed }) {
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const animation = useAnimatePage();
  const styles = useStyles();
  const { pathname } = useLocation();
  const { session } = useAuthContext();
  const { openDrawer } = useDrawerContext();
  const pagesWithZeroPadding = ['/menu', '/advice-screen'];
  const idx = pagesWithZeroPadding.indexOf(pathname);
  const paddingContentStyle = { padding: idx > -1 ? '0' : '20px 24px' };

  function decideMarginLeft(pathname) {
    if (pathname === '/menu' || !session.staff) return 100;
    return 260;
  }
  const headingStyle =
    pathname === '/advice-screen'
      ? {
          margin: '1rem 12px 20px',
          paddingBottom: 10,
          borderBottom: '1px solid #43566C',
        }
      : {};

  const dividerStyle = {
    display: pathname === '/advice-screen' ? 'none' : 'flex',
  };

  return (
    <div className={styles.layoutContainer}>
      <CssBaseline />
      <AppBar className={styles.appBar}>
        <Toolbar>
          <Header pageMayClosed={pageMayClosed} />
        </Toolbar>
      </AppBar>

      <AnimationLayout animation={animation}>
        {session.staff && <Sidebar />}
        <div className={styles.content} style={paddingContentStyle}>
          <Box
            className={styles.main}
            style={{
              marginLeft:
                openDrawer && !matchesSM
                  ? decideMarginLeft(window.location.pathname)
                  : undefined,
            }}
          >
            {title && (
              <>
                <Typography
                  variant="h6"
                  className={styles.heading}
                  style={headingStyle}
                >
                  {title}
                </Typography>
                <span className={styles.Divider} style={dividerStyle} />
              </>
            )}
            {children}
          </Box>
        </div>
      </AnimationLayout>
    </div>
  );
}
